import { render, staticRenderFns } from "./DataComplianceShowList.vue?vue&type=template&id=393cecaa&scoped=true"
import script from "./DataComplianceShowList.vue?vue&type=script&lang=js"
export * from "./DataComplianceShowList.vue?vue&type=script&lang=js"
import style0 from "./DataComplianceShowList.vue?vue&type=style&index=0&id=393cecaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393cecaa",
  null
  
)

export default component.exports